import { Box } from '@palmetto/palmetto-components';
import { useContext, useMemo } from 'react';

import { DocumentFile, RequirementFlagSettingsType } from 'types';

import { QueueFlagsContext } from './QueueFlagsContext';

interface FlagBoxProps {
  displayWithNoQueue?: boolean;
  isLast?: boolean;
  files: DocumentFile[];
  itemId: string;
  flagType?: RequirementFlagSettingsType;
}

export const FlaggedListItems = ({ displayWithNoQueue = false, files, itemId, flagType }: FlagBoxProps) => {
  const { getFlag, getFlagsByFlagType, shouldHide } = useContext(QueueFlagsContext);
  const flaggedFiles = useMemo(() => {
    return files.filter((file: DocumentFile, index: number) => {
      const dataKeyWithSuffix = `${itemId}-${index}`;
      const currentFlag = getFlag([dataKeyWithSuffix, itemId], file.originalName, false);
      const currentFlags = flagType ? getFlagsByFlagType(flagType, false, dataKeyWithSuffix, file.originalName) : [];
      return currentFlags?.length || currentFlag;
    });
  }, [files, flagType, getFlag, getFlagsByFlagType, itemId]);

  return flaggedFiles.length > 0 || !shouldHide || displayWithNoQueue ? (
    <Box>
      <Box fontWeight="medium">Flagged items</Box>
      {flaggedFiles.map((file, index) => (
        <Box key={`${file.md5Hash}-${index}`} fontWeight="light">
          {file.originalName}
        </Box>
      ))}
    </Box>
  ) : null;
};
